import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import * as userCredentialService from "../../../services/training/userCredentialService";
import * as userProfile from "../../../redux/userProfileOverviewRedux";
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCredentialExpiresInColor, dateFilterLogic, dateFilterListRenderer } from "../../../helpers/helper";
import constants from "../../../constants/constants";
import MUIDataTable from "mui-datatables";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import DateFilterComponent from '../../components/DateFilterComponent';

const UserProfileCredential = (props) => {
    const { userProfileState, showAlert, showConfirmModal, hideConfirmModal, auth } = props;
    const [data, setData] = useState([]);
    const [showArchived, setShowArchived] = useState(false);

    useEffect(() => {
        if (props.userProfileState.id > 0)
            loadTableData();
    }, [showArchived])

    const loadTableData = () => {
        userCredentialService.getUserCredentialByUserId(userProfileState.id, showArchived).then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const archiveCredentialToggle = (userCredentialId) => {
        userCredentialService.toggleUserCredentialArchive(userCredentialId).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            loadTableData();
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' })).finally(() => hideConfirmModal());
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                print: false,
                display: auth.isAdmin,
                setCellProps: () => ({
                    'data-aes-field': 'actions',
                    'data-aes-label': 'Actions'
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {
                                // auth.isAdmin || auth.isProjectManager &&
                                    <div className="aes-admin-listing-actions">
                                        <OverlayTrigger
                                            placement={'bottom'}
                                            overlay={
                                                <Tooltip id={`tooltip-right`}>
                                                    Edit
                                                </Tooltip>
                                            }
                                        >
                                            <NavLink
                                                to={"/training/user-credentials/edit-credential/" + data[dataIndex].id}
                                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                            >
                                                <span className="fa fa-edit"></span>
                                            </NavLink>
                                        </OverlayTrigger>
                                        {
                                            data[dataIndex].isArchived ?
                                                <OverlayTrigger
                                                    placement={'bottom'}
                                                    overlay={
                                                        <Tooltip id={`tooltip-right`}>
                                                            Unarchive
                                                        </Tooltip>
                                                    }
                                                >
                                                    <button onClick={() => showConfirmModal({
                                                        title: "Unarchive Credential",
                                                        text: "Are you sure you want to unarchive this credential?",
                                                        rightBtnText: "Confirm",
                                                        btnAction: () => archiveCredentialToggle(data[dataIndex].id)
                                                    })} className="btn btn-warning font-weight-bolder font-size-sm mr-3">
                                                        <span className="fa fa-retweet"></span>
                                                    </button>
                                                </OverlayTrigger> :
                                                <OverlayTrigger
                                                    placement={'bottom'}
                                                    overlay={
                                                        <Tooltip id={`tooltip-right`}>
                                                            Archive
                                                        </Tooltip>
                                                    }
                                                >
                                                    <button onClick={() => showConfirmModal({
                                                        title: "Archive Credential",
                                                        text: "Are you sure you want to archive this credential?",
                                                        rightBtnText: "Confirm",
                                                        btnAction: () => archiveCredentialToggle(data[dataIndex].id)
                                                    })} className="btn bg-info  c-white font-weight-bolder font-size-sm mr-3">
                                                        <span className="fa fa-archive"></span>
                                                    </button>
                                                </OverlayTrigger>
                                        }
                                        &nbsp;
                                    </div>
                            }

                        </>
                    );
                }
            },

        },
        {
            name: "type",
            label: "Type",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'secondary-one',
                    'data-aes-label': 'Type'
                }),
            }
        },
        {
            name: "subType",
            label: "Sub Type",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'secondary-two',
                    'data-aes-label': 'Sub Type'
                }),
            }
        },
        {
            name: "credential",
            label: "Credential",
            options: {
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'primary',
                    'data-aes-label': 'Credential'
                }),
            },
        },
        {
            name: "effectiveDate",
            label: "Effective Date",
            type: 'date',
            options: {
                filter: true,
                sort: true,
                filterType: 'custom',
                setCellProps: () => ({
                    'data-aes-field': 'detail-one',
                    'data-aes-label': 'Effective Date'
                }),
                customFilterListRender: v => dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Effective Date"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                }
            },
        },
        {
            name: "expiryDate",
            label: "Expiry Date",
            options: {
                filter: true,
                sort: true,
                filterType: 'custom',
                setCellProps: () => ({
                    'data-aes-field': 'detail-two',
                    'data-aes-label': 'Expiry Date'
                }),
                customFilterListRender: v => dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Expiry Date"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                }
            }
        },
        {
            name: "expiryDate",
            label: "Expires In",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'detail-four',
                    'data-aes-label': 'Expires In'
                }),
                customBodyRenderLite: (dataIndex) => {
                    let colorArr = getCredentialExpiresInColor(data[dataIndex].expiryDate);

                    return (
                        <>
                            <div className="circle-badge-container">
                                <p><span className={`circle-badge ${colorArr[2]}`}>{colorArr[0]}</span> {colorArr[1]}</p>
                            </div>
                        </>
                    );
                }
            }
        }
    ];

    return (
        <div className="row aes-admin-listing-page aes-admin-listing-page--user-profile-credentials" >
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark archive-unarchive-span">
                                Credentials for {userProfileState.firstName}
                                <OverlayTrigger
                                    key={'right'}
                                    placement={'right'}
                                    overlay={
                                        <Tooltip id={`tooltip-right`}>
                                            Switch to <strong> {showArchived ? "active" : "archived"}</strong>
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        onClick={() => setShowArchived(!showArchived)} style={{ cursor: 'pointer' }}
                                        className={`label label-xl label-inline label-light-${!showArchived ? "primary" : "warning"}`}
                                    >
                                        {!showArchived ? "Active " : "Archived"}
                                    </span>
                                </OverlayTrigger>
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Credentials
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            {
                                auth.isAdmin || auth.isProjectManager ?
                                    <NavLink
                                        to={{
                                            pathname: "/training/user-credentials/edit-credential/" + 0,
                                            state: { userId: userProfileState.id }
                                        }}
                                        className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                        userId={userProfileState.id}
                                    >
                                        <span className="svg-icon svg-icon-lg svg-icon-white">
                                            <SVG
                                                src={toAbsoluteUrl(
                                                    "/media/svg/icons/Code/Plus.svg"
                                                )}
                                            />
                                        </span> Add Credential
                                    </NavLink> : <></>
                            }
                        </div>
                    </div>
                    <div className="container-fluid aes-admin-listing">
                        <MUIDataTable
                            className="aes-admin-listing-surface"
                            data={data}
                            columns={columns}
                            options={{
                                responsive: 'standard',
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                setTableProps: () => ({
                                    className: 'aes-admin-listing-table'
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => ({
    userProfileState: state.userProfile,
    auth: state.auth
});


export default connect(mapStateToProps, {
    ...userProfile.actions,
    ...alert.actions,
    ...confirmModal.actions
})(UserProfileCredential);
